/* eslint-disable @angular-eslint/prefer-standalone */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'percentLocalePipe',
  standalone: false
})
@Injectable({
  providedIn: 'root'
})
export class PercentLocalePipe implements PipeTransform {
  transform(currency: string): string {
    if (navigator.language === 'es-MX') {
      return parseFloat(currency).toLocaleString('en-US', { minimumFractionDigits: 2 });
    }

    return parseFloat(currency).toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
